let tagsList= []
let projectName=''
try {
  if (sessionStorage.tagsList) {
    tagsList = JSON.parse(sessionStorage.tagsList)
  }
} catch (e) {}

export default {
  tagsList,
  ProjectId:'',
  panelStatus:0,
  titleName:'',
  projectName,
  editName:'',
  portraitPic:'',
	keepAlive: []
 // tagsList:[]
}



// WEBPACK FOOTER //
// ./src/store/state.js